import React, { useMemo, useState } from 'react';
import widgetRegistry from './widgetRegistry';
import WidgetSettingsPanel from './WidgetSettingsPanel';
import { computeCardStyle, computeBodyStyle } from './WidgetStyleEditor';

const WidgetContainer = ({ config, meterId, onRemove, onUpdateSettings }) => {
    const meta = widgetRegistry[config.type];
    const WidgetComponent = meta?.component;
    const [showSettings, setShowSettings] = useState(false);

    const cardStyle = computeCardStyle(config.settings);
    const bodyStyle = computeBodyStyle(config.settings);

    // The dashboard-wide meter selection overrides each widget's own
    // settings.meterId, so live widgets all follow the one dropdown
    // instead of being wired to a meter individually.
    const liveConfig = useMemo(() => (
        meterId ? { ...config, settings: { ...config.settings, meterId } } : config
    ), [config, meterId]);

    return (
        <div className="widget-card" style={cardStyle}>
            <div className="widget-card__header widget-drag-handle">
                {meta?.icon && <i className={`${meta.icon} widget-card__icon`}></i>}
                <span className="widget-card__title">{config.title}</span>
                <button
                    type="button"
                    className="widget-card__action"
                    title="Widget settings"
                    onClick={() => setShowSettings(true)}
                >
                    <i className="fas fa-sliders-h"></i>
                </button>
                <button
                    type="button"
                    className="widget-card__remove"
                    title="Remove widget"
                    onClick={() => onRemove(config.id)}
                >
                    <i className="fas fa-times"></i>
                </button>
            </div>
            <div className="widget-card__body" style={bodyStyle}>
                {WidgetComponent ? (
                    <WidgetComponent config={liveConfig} />
                ) : (
                    <div className="widget-card__unknown">Unknown widget type: {config.type}</div>
                )}
            </div>

            {showSettings && (
                <WidgetSettingsPanel
                    config={config}
                    onSave={(updates) => onUpdateSettings(config.id, updates)}
                    onClose={() => setShowSettings(false)}
                />
            )}
        </div>
    );
};

export default WidgetContainer;
